<template>
    <div class="col-md-12 noPadding">
        <div class="product">
            <div class="image">
                <img class="img-responsive" :src="item.image" />
            </div>
            <div class="title">
                <div class="artNum">
                    {{ item.model }}
                </div>
                {{ item.name }}
                <template v-if="item.options.address">
                    <br>
                    <small>
                        {{item.options.address.company}}, {{item.options.address.street}}, {{item.options.address.zip}} {{item.options.address.city}}, {{item.options.address.countryName}}
                    </small>
                </template>
            </div>
            <div class="quantity" v-if="readonly">{{ qty }}</div>
            <div class="quantity" v-else>
                <input class="form-control" type="number" value="1" v-model="qty" @change="updateQty" @input="updateQty" />
            </div>
            <div class="cart"><a class="btn btn-primary"  v-if="!readonly" @click.prevent="remove"><i class="icon-close"></i></a></div>
        </div>
    </div>
</template>

<script>
export default {

    props: {
        item: {
            required: true
        },
        value: {
            type: [String, Number],
            default: 1,
        },
        stock: {
            type: [String, Number],
            required: true,
            default: null
        },
        readonly: {
            default: false
        }
    },

    data() {
        return {
            qty: null,
            loading: false,
            removing: false,
            initialized: false
        }
    },

    created() {
        this.qty = this.value;
        this.$emit('change', this.qty);
    },

    methods: {

        updateQty() {
            if(this.qty < 1) {
                this.qty = 1;
            }
            if(parseInt(this.qty) > parseInt(this.stock)) {
                this.qty = this.stock;
                swal("", "Sie möchten dem Warenkorb mehr Produkte hinzufügen, als auf Lager sind.",  "error");
            } else {
                // Prevent update on first load.
                if (this.initialized) {
                    this.loading = true;
                    new Form({rowId: this.item.rowId, qty:this.qty})
                    .post('/api/cart/update')
                    .then((response) => {
                        App.event.fire('cart.updated', response);
                        this.loading = false;
                    });
                }
                this.initialized = true;
            }
        },

        remove() {
            this.removing = true;
            new Form({rowId: this.item.rowId})
            .post('/api/cart/remove')
            .then((response) => {
                App.event.fire('cart.updated', response);
                this.removing = false;
            });
        }

    }


}
</script>

